import { render, staticRenderFns } from "./SalesDashboardCompanyCountNumber.vue?vue&type=template&id=9b8c366e&"
import script from "./SalesDashboardCompanyCountNumber.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardCompanyCountNumber.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboardCompanyCountNumber.vue?vue&type=style&index=0&id=9b8c366e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports